module.exports = __webpack_public_path__ + "static/media/hero-bedroom-interiors.3dd0d43b.jpg";